/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/3/2023
 */


import DbBaseObject from "@shared/DbBaseObject";
import RefCounter, {refCounterMapTransform} from "@shared/RefCounter";
import {Type, Transform} from "class-transformer";


export default class CompanyIndexItem extends DbBaseObject {

	// @Type(() => CompanyItem)
	// companyItems: CompanyItem[] = []

	// @Transform(refCounterMapTransform)
	@Type(() => RefCounter)
	companyNamesCounter: RefCounter[] = []


	constructor() {
		super();
		this.id = "--companyContainer--" //need this since this is a single instance object and DataManager expects this id or null here.
	}

	getKey(companyName){
		console.log("CompanyIndexItem.getKey = ", companyName)
		return companyName.toLowerCase()
	}

	addCompany(companyName){
		if(companyName){
			let key = this.getKey(companyName)
			let index = this.companyNamesCounter.findIndex(item => this.getKey(item.object) === key)
			let counter = this.companyNamesCounter[index] || new RefCounter()
			counter.addObject(companyName)
			if(index >=0){
				this.companyNamesCounter[index] = counter
			} else {
				this.companyNamesCounter.push(counter)
			}
		}
	}

	removeCompany(companyName){
		if(companyName){
			let key = this.getKey(companyName)
			let index = this.companyNamesCounter.findIndex(item => this.getKey(item.object) === key)

			if(index >= 0){
				let counter = this.companyNamesCounter[index]
				counter.removeObject()
				if(counter.isEmpty()){
					this.companyNamesCounter.splice(index, 1)
				}
			}
		}
	}

	getCompanyNames(){
		return Object.keys(this.companyNamesCounter).filter(key => !!this.companyNamesCounter[key]).map(key => this.companyNamesCounter[key].object)
	}
}
